import {
    SET_IS_VRBUTTON_ENABLED,
    SET_ARE_SHAREBUTTONS_ENABLED,
    SET_ARE_ACTIONBUTTONS_ENABLED,
} from 'aria-viewer/config/configActions'
import { Map } from 'immutable'

const INITIAL_STATE = Map({
    isVRButtonEnabled: true,
    areShareButtonsEnabled: true,
    areActionButtonsEnabled: true,
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_IS_VRBUTTON_ENABLED:
            return state.set('isVRButtonEnabled', action.value)
        case SET_ARE_SHAREBUTTONS_ENABLED:
            return state.set('areShareButtonsEnabled', action.value)
        case SET_ARE_ACTIONBUTTONS_ENABLED:
            return state.set('areActionButtonsEnabled', action.value)
        default:
            return state
    }
}
